export const API_URL = import.meta.env.VITE_APP_URL || "";
export const SESSION_TOKEN = "SESSION_TOKEN";
